// i18n.js — language dictionary (en + es)

export const STRINGS = {
  en: {
    // Nav
    nav_services: "Services",
    nav_how: "How it works",
    nav_area: "Service area",
    nav_schedule: "Schedule",
    nav_reviews: "Reviews",
    nav_city: "Miami, FL",
    nav_book: "Book a visit",
    nav_signin: "Sign in",

    // Hero
    hero_pill: "Whole-home maintenance · membership",
    hero_title_a_1: "We treat your",
    hero_title_a_word: "casa",
    hero_title_a_2: "like our own.",
    hero_sub_a: "Stop wasting time hunting for a handyman. One vetted crew for everything that breaks, leaks, or sticks at home. Membership starts at $39.99/mo — cancel anytime after 2 months.",
    hero_cta_book: "Become a member · $39.99/mo",
    hero_cta_how: "How it works",
    hero_cta_included: "See what's included",
    hero_meta_b: "MIAMI · MEMBERSHIP-BASED HOME CARE",
    hero_title_b_1: "The handyman",
    hero_title_b_word: "your house",
    hero_title_b_2: "deserves.",
    hero_sub_b: "One membership for everything your home needs — repairs, install jobs, the door that won't close. Same crew, every time. From $39.99/mo.",
    hero_meta_c: "EST. 2019 · MIAMI, FL · LIC. #CGC1532001",
    hero_title_c_1: "Everything in your home,",
    hero_title_c_word: "quietly",
    hero_title_c_2: "handled.",
    hero_sub_c: "Membership home care for Miami families. One number, one crew, one flat rate from $39.99/mo. We treat your casa like our own.",
    hero_quote_c: '"una casa bien cuidada"',
    hero_floating_next: "NEXT VISIT · TUE 4:00 PM",
    hero_floating_job: "Leaky faucet + caulk re-seal",
    hero_floating_eta: "Rico C. · arriving 3:52",
    hero_floating_review: "Same crew, every visit. They know our house better than we do.",
    hero_floating_attribution: "— Maria L., Coral Gables",
    hero_trust_count: "Family-run · Miami based · Bilingual crew",

    // Services
    svc_eyebrow: "◆ WHAT WE DO",
    svc_title_1: "Four categories.",
    svc_title_2: "One",
    svc_title_3: "phone number.",
    svc_blurb: "Members get the small stuff handled and a real discount on bigger jobs. We solve about 80% of what breaks in a home — without you having to chase a different tech every time.",
    svc_plumbing: "Plumbing",
    svc_electrical: "Electrical",
    svc_carpentry: "Mounts & Install",
    svc_exterior: "Maintenance",
    svc_appliances: "Appliances",
    svc_ac: "AC & Vents",
    svc_plumbing_items: ["Kitchen & bathroom faucets", "Toilet install & hardware", "Sink install & drains", "Garbage disposal"],
    svc_electrical_items: ["Ceiling lights & fans", "Outlets & switches", "Basic electrical repairs", "Light fixtures"],
    svc_carpentry_items: ["TV mounts", "Floating shelves", "Frames & mirrors", "Door knobs & locks"],
    svc_exterior_items: ["Caulking & re-seals", "Hinge & hardware tightening", "Filter swaps", "Small repairs"],
    svc_appliances_items: ["Diagnostics", "Filter swaps", "Dryer vents", "Install & uninstall"],
    svc_ac_items: ["Filter replacement", "Vent cleaning", "Thermostat install", "Quarterly tune-up"],

    // How it works
    how_eyebrow: "◆ HOW IT WORKS",
    how_title_1: "From",
    how_title_word: "broken",
    how_title_2: "to back to normal — in a day.",
    how_blurb: "Most jobs are scheduled within 48 hours. Emergencies (active leak, no power, lock-out) get a callback in 15 minutes and a crew in four hours.",
    how_status: "3 crews available in Miami today",
    how_steps: [
      { title: "Tell us about your casa", body: "Five-minute intake — square footage, age, what's bugging you. We build a profile so the same crew always knows your home." },
      { title: "Pick a time, drop a deposit", body: "Calendar shows real availability. $49 holds the slot and counts toward your first visit. No subscription pressure." },
      { title: "We arrive on time, in uniform", body: "ETA texts at 30 min and 5 min out. Booties on, drop cloths down. We bring our own coffee." },
      { title: "Fix, document, follow up", body: "Photos before and after. Itemized notes in your dashboard. We text in 7 days to make sure it's still right." },
    ],

    // Service Area
    area_eyebrow: "◆ WHERE WE ROAM",
    area_title_1: "Greater Miami,",
    area_title_word: "door",
    area_title_2: "to door.",
    area_blurb: "Sixteen neighborhoods, one drive time promise — under 35 minutes from dispatch to your door, or your visit is free.",
    area_stat_neighborhoods: "NEIGHBORHOODS",
    area_stat_emergency: "EMERGENCY ETA",
    area_stat_days: "A WEEK",
    area_days_value: "7 days",

    // Scheduler
    sch_eyebrow: "◆ BOOK YOUR FIRST VISIT",
    sch_title_1: "Pick a time",
    sch_title_2: "that",
    sch_title_word: "works",
    sch_title_3: ".",
    sch_blurb: "Real-time availability from our Miami crew. $49 holds your slot and counts toward the visit. Cancel up to 12 hours before, no charge.",
    sch_h_licensed: "Licensed & insured",
    sch_h_licensed_b: "FL CGC1532001 · $2M general liability",
    sch_h_refund: "$49 fully refundable",
    sch_h_refund_b: "Deposit applies to your visit. Cancel 12+ hrs ahead, no charge.",
    sch_h_crew: "Same crew, every time",
    sch_h_crew_b: "We assign one home pro to your casa for continuity.",
    sch_crew_today: "Today's Miami crew",
    sch_crew_meta: "3 pros · avg 9 yrs experience",
    sch_steps: ["Service", "Date & time", "Details", "Payment", "Confirmed"],
    sch_step1_title: "What can we help with?",
    sch_step1_blurb: "Pick the visit type. You can describe specifics in the next steps.",
    sch_step2_title: "Pick a date & time",
    sch_step2_tz: "EST · America/New_York",
    sch_step2_pickdate: "Select a date",
    sch_step2_pickdate_hint: "← Pick a date to see available slots",
    sch_step2_legend_avail: "Available",
    sch_step2_legend_closed: "Sundays closed",
    sch_step3_title: "Where should we go?",
    sch_step3_blurb: "We'll text confirmations to your phone.",
    sch_label_name: "FULL NAME",
    sch_label_email: "EMAIL",
    sch_label_phone: "PHONE",
    sch_label_address: "HOME ADDRESS",
    sch_label_notes: "WHAT'S GOING ON? (OPTIONAL)",
    sch_ph_name: "Maria Lopez",
    sch_ph_email: "maria@email.com",
    sch_ph_phone: "(305) 555-0142",
    sch_ph_address: "2455 SW 17th Ave, Miami, FL 33145",
    sch_ph_notes: "Kitchen faucet drips when off; bathroom door sticks in summer.",
    sch_step4_deposit: "Hold your slot with $49",
    sch_step4_full: "Pay in full",
    sch_step4_card: "Card on file",
    sch_step4_deposit_b: "Refundable up to 12 hrs before. Applies to your visit.",
    sch_step4_full_b: "Pay the full estimate now, refundable up to 12 hrs before.",
    sch_step4_card_b: "We'll charge after the visit, only what's owed.",
    sch_total_today: "Total today",
    sch_card_number: "CARD NUMBER",
    sch_expiry: "EXPIRY",
    sch_cvc: "CVC",
    sch_zip: "ZIP",
    sch_secured: "Secured by Stripe · 256-bit TLS · PCI DSS Level 1",
    sch_back: "← Back",
    sch_continue: "Continue →",
    sch_continue_pay: "Continue to payment →",
    sch_processing: "Processing…",
    sch_pay_card_save: "Save card & confirm",
    sch_step5_title_pre: "You're booked,",
    sch_step5_title_default: "neighbor",
    sch_step5_blurb_pre: "Confirmation sent to",
    sch_step5_blurb_post: ". We'll text you 24 hrs and 30 min before your visit.",
    sch_booking: "BOOKING",
    sch_when: "WHEN",
    sch_where: "WHERE",
    sch_crew: "CREW",
    sch_paid: "PAID",
    sch_crew_assigned: "Rico C. (will text on arrival)",
    sch_book_another: "Book another",
    sch_add_cal: "Add to calendar",
    sch_services: [
      { id: "diag", name: "Home Diagnostic Visit", duration: "60 min", desc: "We walk your home, document issues, and propose a plan.", price: 49 },
      { id: "fix", name: "Single Repair Visit", duration: "Up to 2 hr", desc: "One job — leaky faucet, sticky door, fan install. Members save 30%.", price: 49 },
      { id: "tune", name: "Quarterly Tune-Up", duration: "2–3 hr", desc: "Filter swaps, caulk re-seals, smoke detectors, hinge tightening.", price: 49 },
      { id: "emer", name: "Emergency (4-hr ETA)", duration: "ASAP", desc: "Active leak, no power, lock-out. Members only.", price: 99 },
    ],
    sch_hold: "HOLD",
    months: ["January","February","March","April","May","June","July","August","September","October","November","December"],
    months_short: ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],
    dow: ["Su","Mo","Tu","We","Th","Fr","Sa"],
    dow_full: ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],

    // Testimonials
    rev_eyebrow: "◆ NEIGHBORS WHO TRUST US",
    rev_title_1: "Real Miami homes,",
    rev_title_word: "one",
    rev_title_2: "very loyal crew.",
    rev_meta: "Verified · Miami members",
    rev_member: "member since 2024",
    reviews: [
      { name: "Maria L.", area: "Coral Gables", body: "Same crew, every visit. They know our 1962 house better than we do. Last week Rico noticed our water heater was about to go and replaced it before it flooded the garage." },
      { name: "Daniel K.", area: "Brickell", body: "The $49 deposit thing is brilliant — I stopped calling random handymen who never show. Membership pays for itself in two visits." },
      { name: "Anabel T.", area: "Coconut Grove", body: "Booked Sunday night, fixed Monday morning. They documented everything in the app so I could send it to my landlord." },
      { name: "Jorge R.", area: "Little Havana", body: "Mi casa, su problema. They speak English and Spanish, treat my abuela's house with respect, and the prices are honest." },
    ],

    // Membership
    mem_eyebrow: "◆ MEMBERSHIP",
    mem_title_1: "Pick the plan that fits",
    mem_title_2: "your",
    mem_title_word: "casa",
    mem_title_3: ".",
    mem_blurb: "A flat monthly rate to keep your home running. Cancel anytime after 2 months — no contracts, no fine print.",
    mem_popular: "MOST POPULAR",
    mem_choose: "Choose",
    mem_per: "month",
    tiers: [
      { name: "Basic", price: 39.99, desc: "Get started without commitment", features: ["1 home visit per month","Up to 1 hour per visit","Basic repairs covered","48-hour response time","Materials sold separately"] },
      { name: "Pro", price: 69.99, desc: "Where the membership really pays off", features: ["2 visits per month included","Up to 2 hours per visit","Priority scheduling (24–36 hrs)","Discount on bigger jobs","Same trusted crew, every time"] },
      { name: "Premium", price: 99.99, desc: "Larger homes or hands-off owners", features: ["4 visits per month included","VIP priority — same or next day","Direct support, we resolve it now","Small materials included (screws, seals)","Annual home health report"] },
    ],

    // Rules
    rules_eyebrow: "◆ CLEAR RULES",
    rules_title_1: "Honest scope,",
    rules_title_word: "no surprises",
    rules_title_2: ".",
    rules_blurb: "We tell you up front what's covered, what isn't, and how long a visit can take. That's how the membership keeps working — for you and for us.",
    rules_yes_h: "WHAT'S INCLUDED",
    rules_no_h: "OUT OF SCOPE",
    rules_extra_h: "FINE PRINT (THE GOOD KIND)",
    rules_yes_items: ["Basic plumbing fixtures", "Basic electrical work", "Mounts, shelves & install", "Caulking, sealing & finishes", "Small hardware swaps"],
    rules_no_items: ["Major plumbing or repipes", "Complex electrical work", "Remodels & demolition", "Roof or structural repairs"],
    rules_extra_items: ["Set time limit per visit (clear up front)", "Service area: Miami & nearby zones", "Extra visits = additional charge", "Materials sold at cost on bigger jobs"],

    // Footer
    foot_blurb: "Whole-home maintenance for Miami families. We treat your casa like our own — because mostly, we live in this neighborhood too.",
    foot_addr: ["FixMyCasa, LLC","2455 SW 17th Ave, Miami FL 33145","FL CGC1532001 · Bonded · Insured"],
    foot_services_h: "SERVICES",
    foot_company_h: "COMPANY",
    foot_hello_h: "HELLO",
    foot_company_items: ["About us", "Our crews", "Service area", "Membership", "Press", "Careers"],
    foot_hours: "Mon–Sat · 7am–7pm",
    foot_emergencies: "Emergencies 24/7",
    foot_copyright: "© 2026 FixMyCasa, LLC · Made with love in Miami",
    foot_terms: "Terms",
    foot_privacy: "Privacy",
    foot_sitemap: "Sitemap",

    acct: {
      nav: {
        home: "Home",
        visits: "Visits",
        active_visit: "Active visit",
        documents: "Documents",
        properties: "Properties",
        membership: "Membership",
        refer: "Refer a friend",
        profile: "Profile",
        notifs: "Notifications",
        settings: "Settings",
        casa: "CASA",
        account: "ACCOUNT",
        sign_out: "Sign out",
        book_visit: "Book visit",
        live: "LIVE",
        search_ph: "Search visits, docs, pros…",
      },
      dashboard: {
        greeting_pre: "Buenas,",
        attention_pre: "3 items want attention.",
        attention_post: "Your crew arrives in 3 days.",
        home_health: "HOME HEALTH",
        doing: "Doing",
        well: "well.",
        summary: "Your 1962 home is holding up nicely. 3 small items flagged for next visit; nothing urgent.",
        visits_since: "VISITS SINCE 2022",
        saved_vs: "SAVED VS À LA CARTE",
        days_streak: "DAYS SINCE LAST FIX",
        days_value: "12 days",
        next_visit: "NEXT VISIT · IN 3 DAYS",
        in_3_days: "IN 3 DAYS",
        tune_up: "Quarterly tune-up",
        slot: "Tue, Apr 28 · 4:00–7:00 PM · 2455 SW 17th",
        by_room: "By room",
        recommended_next: "Recommended next",
        recent_activity: "Recent activity",
        view_history: "VIEW HISTORY →",
        view_all: "ALL →",
        confirm_details: "Confirm details →",
        reschedule: "Reschedule",
        request_emergency: "Request emergency",
        included_in_plan: "Add 2 items to next visit · +$0 included",
        greeting_date: "TUESDAY, APR 24",
        your_usual_crew: "YOUR USUAL CREW · 9 YRS · 47 VISITS",
        planned_label: "PLANNED:",
        planned_items: "Filter swap · Caulk re-seal · Smoke detector test · +2",
        rooms: [
          { name: "Kitchen",      health: 92, last: "12 days ago", items: 0, color: "var(--sage)",       icon: "🍳" },
          { name: "Primary bath", health: 78, last: "5 mo ago",    items: 1, color: "var(--gold)",       icon: "🚿" },
          { name: "Guest bath",   health: 65, last: "8 mo ago",    items: 2, color: "var(--terracotta)", icon: "🛁" },
          { name: "Living room",  health: 88, last: "12 days ago", items: 0, color: "var(--sage)",       icon: "🛋" },
          { name: "Laundry",      health: 71, last: "4 mo ago",    items: 1, color: "var(--gold)",       icon: "🌀" },
          { name: "Patio & roof", health: 54, last: "11 mo ago",   items: 3, color: "var(--terracotta)", icon: "🌴" },
        ],
        last_label: "LAST:",
        item_label: "ITEM",
        items_label: "ITEMS",
        recommendations: [
          { title: "Re-caulk guest bath tub", reason: "Last sealed 8 mo ago; small mildew at seam.", time: "30 min", room: "Guest bath" },
          { title: "Replace AC filter (4-pack)", reason: "Last swap 11 weeks ago. We bring filters.", time: "10 min", room: "Hallway" },
          { title: "Tighten patio screen frame", reason: "Photo from last visit showed warping at NW corner.", time: "20 min", room: "Patio" },
        ],
        added: "ADDED",
        add: "ADD",
        activity: [
          { ts: "Apr 12 · 3:14 pm", who: "Rico C.", what: "Replaced kitchen disposal flange · 47 min", tag: "FIX", color: "var(--sage)" },
          { ts: "Apr 12 · 3:48 pm", who: "Rico C.", what: "Uploaded 6 before/after photos to Kitchen", tag: "DOC", color: "var(--gold)" },
          { ts: "Apr 02 · 8:02 am", who: "System",  what: "Quarterly tune-up scheduled · Apr 28", tag: "BOOK", color: "var(--terracotta)" },
          { ts: "Mar 14 · 4:21 pm", who: "Ana M.",  what: "Caulk re-seal · primary bath", tag: "FIX", color: "var(--sage)" },
        ],
      },
      manage: {
        visits: {
          title_1: "Every visit,",
          title_2: "documented.",
          since: "47 VISITS SINCE NOV 2022",
          year_filter: "2026",
          all_categories: "All categories",
          export_csv: "Export CSV",
          col_job: "JOB",
          col_date: "DATE",
          col_pro: "PRO · TIME",
          col_cost: "COST",
          col_status: "STATUS",
          total_visits: "TOTAL VISITS",
          hrs_work: "HRS OF WORK",
          photos_logged: "PHOTOS LOGGED",
          saved_vs_acart: "SAVED VS À LA CARTE",
          upcoming: "Upcoming",
          done: "Done",
          cancelled: "Cancelled",
          included: "Included",
          history: [
            { id: "FMC-48217", title: "Quarterly tune-up",          date: "Apr 28, 2026", status: "upcoming", pro: "Rico C.", duration: "—",          cost_key: "included", room: "Whole house",  room_key: "WHOLE HOUSE",  tags: ["TUNE-UP"] },
            { id: "FMC-48104", title: "Disposal flange swap",       date: "Apr 12, 2026", status: "done",     pro: "Rico C.", duration: "47 MIN",      cost_key: "included", room: "Kitchen",      room_key: "KITCHEN",      tags: ["PLUMBING"],            photos: 6 },
            { id: "FMC-47992", title: "Caulk re-seal · primary bath",date: "Mar 14, 2026",status: "done",     pro: "Ana M.", duration: "1 HR 12 MIN", cost_key: "included", room: "Primary bath", room_key: "PRIMARY BATH", tags: ["CARPENTRY"],           photos: 4 },
            { id: "FMC-47884", title: "Emergency · AC drain clog",  date: "Feb 28, 2026", status: "done",     pro: "Rico C.", duration: "2 HR 4 MIN",  cost: "$110",         room: "Hallway",      room_key: "HALLWAY",      tags: ["AC","EMERGENCY"],      photos: 8 },
            { id: "FMC-47720", title: "Q1 quarterly tune-up",       date: "Jan 21, 2026", status: "done",     pro: "Rico C.", duration: "2 HR 35 MIN", cost_key: "included", room: "Whole house",  room_key: "WHOLE HOUSE",  tags: ["TUNE-UP"],             photos: 12 },
            { id: "FMC-47602", title: "Smoke alarm batteries (×4)", date: "Dec 14, 2025", status: "done",     pro: "Ana M.", duration: "22 MIN",       cost_key: "included", room: "Hallways",     room_key: "HALLWAYS",     tags: ["SAFETY"],              photos: 2 },
          ],
          room_tags: {
            "KITCHEN": "KITCHEN",
            "PRIMARY BATH": "PRIMARY BATH",
            "HALLWAY": "HALLWAY",
            "HALLWAYS": "HALLWAYS",
            "WHOLE HOUSE": "WHOLE HOUSE",
          },
          cat_tags: {
            "TUNE-UP": "TUNE-UP",
            "PLUMBING": "PLUMBING",
            "CARPENTRY": "CARPENTRY",
            "AC": "AC",
            "EMERGENCY": "EMERGENCY",
            "SAFETY": "SAFETY",
          },
        },
        properties: {
          title_1: "Casas in your",
          title_2: "care.",
          since: "3 PROPERTIES · 2 PLANS",
          add_property: "Add a property",
          book_visit: "Book a visit",
          open_dashboard: "Open dashboard",
          primary: "PRIMARY",
          last_visit: "LAST VISIT",
          square_feet: "SIZE",
          year_built: "YEAR · VISITS",
          manage_access: "MANAGE ACCESS",
          invite_family: "OR INVITE A FAMILY MEMBER",
          health_col: "HEALTH",
          plan_col: "PLAN",
          role_primary: "PRIMARY",
          role_caretaker: "CARETAKER",
          role_owner: "OWNER",
        },
        membership: {
          title_1: "You're on",
          title_2_brand: "Casa.",
          plan_active: "ACTIVE",
          member_since: "MEMBER SINCE NOV 14, 2022",
          visits: "Q2 VISITS",
          used: "of 2 used",
          small_jobs: "SMALL JOBS",
          this_year: "this year",
          unlimited: "unlimited",
          upgrade: "Upgrade to Hacienda · $149",
          manage_plan: "Manage plan",
          payment: "Payment",
          default_card: "FIXMYCASA · DEFAULT",
          cardholder: "CARDHOLDER",
          backup_card: "Add backup card",
          billing_history: "Billing history",
          invoice: "INVOICE",
          date: "DATE",
          amount: "AMOUNT",
          status: "STATUS",
          paid: "Paid",
          download_all: "DOWNLOAD ALL ↓",
          plan_blurb: "Two visits per quarter, unlimited 60-min jobs, 30% off larger repairs.",
          plan_name_label: "YOUR PLAN",
          plan_name: "Casa · $79/mo",
          invoices: [
            { id: "INV-2604-MO",  date: "Apr 15, 2026", amt: "$79.00",  what: "Casa · Monthly · April" },
            { id: "INV-2604-EMR", date: "Feb 28, 2026", amt: "$110.00", what: "AC drain clog · emergency (members)" },
            { id: "INV-2603-MO",  date: "Mar 15, 2026", amt: "$79.00",  what: "Casa · Monthly · March" },
            { id: "INV-2602-MO",  date: "Feb 15, 2026", amt: "$79.00",  what: "Casa · Monthly · February" },
            { id: "INV-2601-MO",  date: "Jan 15, 2026", amt: "$79.00",  what: "Casa · Monthly · January" },
          ],
        },
        documents: {
          title_1: "Your home's",
          title_2: "paper trail.",
          blurb: "Warranties, receipts, inspections, and every photo we've ever taken. All searchable. All yours forever.",
          upload: "Upload",
          search_ph: "Search docs, rooms, dates…",
          all_tab: "All",
          warranties: "Warranties · 8",
          receipts: "Receipts · 11",
          photos: "Photos · 284",
          inspections: "Inspections · 4",
          before_after: "Before / after photos",
          warranties_section: "Warranties & receipts",
          from_label: "FROM",
          exp_label: "EXP",
          more_view: "MORE VIEW →",
          grid_view: "GRID VIEW →",
          photos_label: "PHOTOS",
          docs: [
            { name: "AC condenser warranty · Trane",        t: "WARRANTY",   date: "Mar 2024", exp: "Mar 2034", color: "var(--sage)" },
            { name: "Water heater receipt · Rheem",         t: "RECEIPT",    date: "Jan 2025", exp: "—",        color: "var(--gold)" },
            { name: "Roof inspection · Stevenson Roofing",  t: "INSPECTION", date: "Nov 2025", exp: "—",        color: "var(--terracotta)" },
            { name: "Garbage disposal · InSinkErator",      t: "WARRANTY",   date: "Apr 2026", exp: "Apr 2030", color: "var(--sage)" },
            { name: "Insurance — Citizens",                 t: "INSURANCE",  date: "Aug 2025", exp: "Aug 2026", color: "var(--gold)" },
          ],
          doc_tags: {
            "WARRANTY": "WARRANTY",
            "RECEIPT": "RECEIPT",
            "INSPECTION": "INSPECTION",
            "INSURANCE": "INSURANCE",
          },
          photo_cards: [
            { room: "Kitchen",      date: "Apr 12", count: 6,  label: "Disposal swap" },
            { room: "Primary bath", date: "Mar 14", count: 4,  label: "Caulk re-seal" },
            { room: "Hallway",      date: "Feb 28", count: 8,  label: "AC emergency" },
            { room: "Whole house",  date: "Jan 21", count: 12, label: "Q1 tune-up" },
            { room: "Patio",        date: "Dec 03", count: 5,  label: "Screen tighten" },
            { room: "Garage",       date: "Nov 14", count: 4,  label: "Light fixture" },
          ],
        },
      },
      active_visit: {
        eyebrow: "VISIT TIMELINE",
        miles_away_pre: "Rico is",
        miles_away_word: "2 miles",
        miles_away_post: "away.",
        blurb: "He'll text on arrival. Booties on, drop cloths down — you know the drill.",
        call_rico: "Call Rico",
        message_crew: "Message crew",
        arrives: "◆ ARRIVES",
        in_8_min: "IN 8 MIN",
        your_home: "YOUR HOME",
        shop: "SHOP · 9:32 AM",
        eta_time: "10:08",
        timeline_title: "Quarterly tune-up",
        visit_name: "Today · Rico C.",
        step1: "Job scheduled & confirmed",
        step2: "Crew dispatched from shop",
        step3: "Picked up parts at Home Depot",
        step4: "Arriving at your home",
        step5: "Start walkthrough · 60 min est.",
        step6: "Wrap up · photos uploaded",
        expect_today_label: "WHAT TO EXPECT TODAY",
        expect_today_body: "Filter swap · Caulk re-seal (2 baths) · Smoke detector test · Patio screen check · Drain runoff inspection",
        crew_name: "Rico Cabrera",
        crew_meta: "VAN 03 · LIC #F-2841",
        live_pill: "Live · arriving in 8 min",
      },
      profile: {
        title: "Your info",
        you: "Your info",
        addresses: "Addresses",
        notifs: "Notifications",
        payment: "Payment",
        language: "Language",
        security: "Security",
        data_privacy: "Data & privacy",
        sign_out: "Sign out",
        your_info: "Your info",
        member_no: "MEMBER #FMC-1247 · CORAL GABLES",
        change_photo: "Change photo",
        first_name: "First name",
        last_name: "Last name",
        email: "Email",
        phone: "Phone",
        verified: "Verified",
        how_we_reach: "How we reach you",
        saved_ago: "SAVED 2 MIN AGO",
        text: "TEXT",
        email_col: "EMAIL",
        push: "PUSH",
        call: "CALL",
        pro_eta: "Pro is on the way (30-min ETA)",
        pro_eta_desc: "Texts you when crew leaves the shop",
        pro_arrived: "Pro has arrived",
        pro_arrived_desc: "Knock courtesy alert",
        visit_complete: "Visit complete + photos uploaded",
        visit_complete_desc: "Includes itemized notes",
        reminder_24: "Upcoming visit · 24 hr reminder",
        recommended_items: "Recommended items for next visit",
        recommended_items_desc: "Quarterly nudges, no pressure",
        emergency_updates: "Emergency dispatch updates",
        emergency_updates_desc: "Crew location every 5 min",
        membership_billing: "Membership / billing",
        membership_billing_desc: "Receipts, renewals, card changes",
        tips_digest: "Tips & home health digest",
        tips_digest_desc: "Monthly · cancel anytime",
        quiet_hours: "Quiet hours",
        quiet_hours_blurb: "We won't text or call between these hours unless it's an emergency you started.",
        mon_fri: "MON–FRI",
        sat: "SAT",
        sun: "SUN",
        account_actions: "Account actions",
        account_actions_blurb: "Pause membership keeps your home history. Deleting removes everything in 30 days.",
        pause_membership: "Pause membership",
        delete_account: "Delete account",
        settings_label: "◆ SETTINGS",
      },
      notifs: {
        eyebrow: "◆ INBOX · 5 RECENT",
        inbox_count: "5 RECENT",
        title_1: "What's happening at",
        title_2_word: "your casa.",
        mark_all_read: "Mark all read",
        visit_confirmed: "Visit confirmed",
        visit_confirmed_body: "Quarterly tune-up · Tue Apr 28, 4:00 PM. Rico C. will text 30 min before he arrives.",
        filter_low: "Filter low",
        filter_low_body: "Your kitchen vent filter is reading 28% remaining — we'll swap it next visit.",
        photos_uploaded: "Photos uploaded",
        photos_uploaded_body: "Rico added 6 before/after photos from your disposal flange swap.",
        receipt_available: "Receipt available",
        receipt_available_body: "Caulk re-seal · primary bath — invoice ready for download.",
        membership_renewed: "Membership renewed",
        membership_renewed_body: "Casa plan auto-renewed — $79 charged to Visa •• 4242.",
        just_now: "Just now",
        ago_2h: "2 hr ago",
        yesterday: "Yesterday",
        ago_apr14: "Apr 14",
        ago_apr9: "Apr 9",
      },
      settings: {
        eyebrow: "◆ ACCOUNT",
        title_1: "Your",
        title_2_word: "preferences.",
        language_label: "Language",
        language_help: "English · Spanish",
        language_action: "Change",
        tz_label: "Time zone",
        tz_help: "America/New_York (EST)",
        tz_action: "Change",
        receipts_label: "Receipts & exports",
        receipts_help: "Auto-email receipts after every visit",
        receipts_action: "Configure",
        connected_label: "Connected services",
        connected_help: "Google Calendar, Apple Pay, none",
        connected_action: "Manage",
        twofa_label: "Two-factor auth",
        twofa_help: "On · text to (305) 555-0142",
        twofa_action: "Manage",
        signout_label: "Sign out everywhere",
        signout_help: "Force a fresh sign-in on every device",
        signout_action: "Sign out",
        delete_label: "Delete account",
        delete_help: "Removes your profile and history after 30 days",
        delete_action: "Delete",
      },
      refer: {
        eyebrow: "◆ GIVE $25, GET $25",
        title_1: "Bring a neighbor,",
        title_word: "save",
        title_2: "together.",
        blurb: "For every Miami friend who joins FixMyCasa with your code, you both get $25 off your next visit. We pay it forward — most members refer 2 neighbors in their first year.",
        your_code: "YOUR CODE",
        copy: "Copy",
        or_share: "Or share your invite link:",
        link_pre: "fixmycasa.miami/r/maria-casa",
      },
      auth: {
        common: {
          continue_google: "Continue with Google",
          continue_apple: "Continue with Apple",
          continue_phone: "Continue with phone number",
          or_use_email: "OR USE EMAIL",
          first_name: "First name",
          last_name: "Last name",
          email: "Email",
          password: "Password",
          sign_up: "Sign up",
          sign_in: "Sign in",
          forgot: "FORGOT?",
          reset: "Reset password",
          remember_me: "Keep me signed in on this laptop",
        },
        signup: {
          step_1_of_2: "STEP 1 OF 2",
          title: "Create your account",
          blurb: "Takes 30 seconds. No card needed to sign up — only for booking.",
          terms: "I agree to the Terms and Privacy Policy. Text me visit updates.",
          create_account: "Create account",
          already_member: "Already a member?",
          sign_in_link: "Sign in",
          left_eyebrow: "◆ FOR MIAMI FAMILIES",
          left_title_1: "Your casa,",
          left_title_word: "quietly",
          left_title_2: "handled.",
          left_blurb: "One account. One crew that learns your home. We text on the way, send photos, and keep notes you can search later.",
          benefit_book_title: "Two-tap booking",
          benefit_book_body: "Reschedule, swap services, or request emergency in three taps.",
          benefit_doc_title: "Every visit, documented",
          benefit_doc_body: "Before/after photos, warranties, receipts — searchable forever.",
          benefit_reminders_title: "Quarterly reminders",
          benefit_reminders_body: "We nudge you when filters, caulk, or smoke alarms need love.",
          joining_count: "Joining 2,847 Miami homes",
          pw_strong: "STRONG",
          pw_chars: "12 chars",
          pw_case: "mixed case",
          pw_num: "number",
          pw_hint: "STRONG · 12 chars, mixed case, number",
        },
        signin: {
          eyebrow: "◆ WELCOME BACK",
          title_1: "Hola again,",
          title_word: "neighbor.",
          blurb: "Your home's history, your crew, your next visit — all where you left them.",
          forgot_link: "FORGOT?",
          keep_signed_in: "Keep me signed in on this laptop",
          sign_in_button: "Sign in",
          new_here: "New here?",
          create_account_link: "Create an account →",
          right_eyebrow: "YOUR NEXT VISIT",
          right_subtitle: "9 yrs · your crew",
          your_next_visit: "Quarterly tune-up",
          next_visit_date: "Tue, Apr 28 · 4:00–7:00 PM",
          upcoming: "Upcoming",
          home_health_score: "HOME HEALTH",
          items_flagged: "3 items flagged · 7 looking great",
          looking_great: "87 · Good",
          quote: '"They know our 1962 house better than we do."',
          quote_author: "— MARIA L., CORAL GABLES · MEMBER",
        },
        forgot: {
          title: "Forgot your",
          title_word: "password?",
          blurb: "No drama. Enter your email and we'll send a reset link. Expires in 30 minutes.",
          send_link: "Send reset link",
          back_to_signin: "← BACK TO SIGN IN",
        },
        reset: {
          title: "Set a new",
          title_word: "password.",
          blurb: "Choose something strong. At least 8 characters with a mix of letters and numbers.",
          new_password: "New password",
          confirm_password: "Confirm new password",
          save_password: "Reset password",
          back_to_signin: "← BACK TO SIGN IN",
        },
      },
    },
  },

  es: {
    nav_services: "Servicios",
    nav_how: "Cómo funciona",
    nav_area: "Área de servicio",
    nav_schedule: "Agendar",
    nav_reviews: "Reseñas",
    nav_city: "Miami, FL",
    nav_book: "Reservar visita",
    nav_signin: "Iniciar sesión",

    hero_pill: "Mantenimiento integral del hogar · membresía",
    hero_title_a_1: "Cuidamos tu",
    hero_title_a_word: "casa",
    hero_title_a_2: "como la nuestra.",
    hero_sub_a: "Deja de perder tiempo buscando handyman. Un equipo de mantenimiento de confianza para todo lo que se rompe, gotea o se atasca en casa. Membresía desde $39.99/mes — cancela cuando quieras después de 2 meses.",
    hero_cta_book: "Hazte miembro · $39.99/mes",
    hero_cta_how: "Cómo funciona",
    hero_cta_included: "Qué incluye",
    hero_meta_b: "MIAMI · CUIDADO DEL HOGAR POR MEMBRESÍA",
    hero_title_b_1: "El handyman que",
    hero_title_b_word: "tu casa",
    hero_title_b_2: "merece.",
    hero_sub_b: "Una membresía para todo lo que tu casa necesita — reparaciones, instalaciones, esa puerta que no cierra. El mismo equipo, siempre. Desde $39.99/mes.",
    hero_meta_c: "DESDE 2019 · MIAMI, FL · LIC. #CGC1532001",
    hero_title_c_1: "Todo en tu hogar,",
    hero_title_c_word: "tranquilamente",
    hero_title_c_2: "resuelto.",
    hero_sub_c: "Cuidado del hogar por membresía para familias de Miami. Un número, un equipo, una cuota fija desde $39.99/mes. Cuidamos tu casa como la nuestra.",
    hero_quote_c: '"una casa bien cuidada"',
    hero_floating_next: "PRÓXIMA VISITA · MAR 4:00 PM",
    hero_floating_job: "Llave que gotea + sellado",
    hero_floating_eta: "Rico C. · llega 3:52",
    hero_floating_review: "El mismo equipo, cada visita. Conocen nuestra casa mejor que nosotros.",
    hero_floating_attribution: "— Maria L., Coral Gables",
    hero_trust_count: "Negocio familiar · Basados en Miami · Equipo bilingüe",

    svc_eyebrow: "◆ LO QUE HACEMOS",
    svc_title_1: "Cuatro categorías.",
    svc_title_2: "Un",
    svc_title_3: "solo número.",
    svc_blurb: "Los miembros resuelven lo pequeño sin esperar y reciben descuento en lo grande. Cubrimos cerca del 80% de lo que se rompe en una casa — sin que tengas que llamar a un técnico distinto cada vez.",
    svc_plumbing: "Plomería",
    svc_electrical: "Electricidad",
    svc_carpentry: "Montajes e Instalación",
    svc_exterior: "Mantenimiento",
    svc_appliances: "Electrodomésticos",
    svc_ac: "AC y Ventilación",
    svc_plumbing_items: ["Llaves de cocina y baño", "Inodoros y herrajes", "Fregaderos y desagües", "Triturador de basura"],
    svc_electrical_items: ["Lámparas y ventiladores de techo", "Tomacorrientes y switches", "Reparaciones eléctricas básicas", "Luminarias"],
    svc_carpentry_items: ["Soportes de TV", "Estantes flotantes", "Cuadros y espejos", "Llavines de puertas"],
    svc_exterior_items: ["Sellados y caulk", "Ajuste de bisagras y herrajes", "Cambio de filtros", "Pequeñas reparaciones"],
    svc_appliances_items: ["Diagnósticos", "Cambio de filtros", "Ductos de secadora", "Instalación"],
    svc_ac_items: ["Cambio de filtros", "Limpieza de ductos", "Instalación termostato", "Mantenimiento trimestral"],

    how_eyebrow: "◆ CÓMO FUNCIONA",
    how_title_1: "De",
    how_title_word: "roto",
    how_title_2: "a normal — en un día.",
    how_blurb: "La mayoría de los trabajos se agendan en 48 horas. Emergencias (fuga activa, sin luz, te quedaste afuera) reciben llamada en 15 minutos y equipo en cuatro horas.",
    how_status: "3 equipos disponibles hoy en Miami",
    how_steps: [
      { title: "Cuéntanos sobre tu casa", body: "Cuestionario de cinco minutos — pies cuadrados, edad, qué te molesta. Creamos un perfil para que el mismo equipo siempre conozca tu hogar." },
      { title: "Elige hora, paga depósito", body: "El calendario muestra disponibilidad real. $49 reservan tu cita y se aplican a tu primera visita. Sin presión de suscripción." },
      { title: "Llegamos a tiempo, uniformados", body: "Avisos de llegada a los 30 y 5 minutos. Cubrezapatos puestos, alfombrillas abajo. Traemos nuestro propio café." },
      { title: "Arreglar, documentar, dar seguimiento", body: "Fotos antes y después. Notas detalladas en tu panel. Te escribimos en 7 días para confirmar que todo sigue bien." },
    ],

    area_eyebrow: "◆ POR DÓNDE ANDAMOS",
    area_title_1: "Greater Miami,",
    area_title_word: "puerta",
    area_title_2: "a puerta.",
    area_blurb: "Dieciséis vecindarios, una promesa de tiempo de manejo — menos de 35 minutos de despacho a tu puerta, o tu visita es gratis.",
    area_stat_neighborhoods: "VECINDARIOS",
    area_stat_emergency: "ETA EMERGENCIA",
    area_stat_days: "A LA SEMANA",
    area_days_value: "7 días",

    sch_eyebrow: "◆ RESERVA TU PRIMERA VISITA",
    sch_title_1: "Elige la hora",
    sch_title_2: "que te",
    sch_title_word: "funcione",
    sch_title_3: ".",
    sch_blurb: "Disponibilidad en tiempo real de nuestro equipo de mantenimiento en Miami. $49 reservan tu cita y se aplican a la visita. Cancela hasta 12 horas antes, sin cargo.",
    sch_h_licensed: "Licenciado y asegurado",
    sch_h_licensed_b: "FL CGC1532001 · $2M de responsabilidad civil",
    sch_h_refund: "$49 totalmente reembolsables",
    sch_h_refund_b: "El depósito se aplica a tu visita. Cancela 12+ hrs antes, sin cargo.",
    sch_h_crew: "El mismo equipo, siempre",
    sch_h_crew_b: "Asignamos un profesional fijo a tu casa para continuidad.",
    sch_crew_today: "Equipo de Miami hoy",
    sch_crew_meta: "3 profesionales · 9 años de experiencia promedio",
    sch_steps: ["Servicio", "Fecha y hora", "Detalles", "Pago", "Confirmado"],
    sch_step1_title: "¿En qué te ayudamos?",
    sch_step1_blurb: "Elige el tipo de visita. Puedes detallar lo específico en los siguientes pasos.",
    sch_step2_title: "Elige fecha y hora",
    sch_step2_tz: "EST · America/New_York",
    sch_step2_pickdate: "Selecciona una fecha",
    sch_step2_pickdate_hint: "← Elige una fecha para ver los horarios",
    sch_step2_legend_avail: "Disponible",
    sch_step2_legend_closed: "Cerrado domingos",
    sch_step3_title: "¿A dónde vamos?",
    sch_step3_blurb: "Te enviaremos la confirmación por mensaje.",
    sch_label_name: "NOMBRE COMPLETO",
    sch_label_email: "CORREO",
    sch_label_phone: "TELÉFONO",
    sch_label_address: "DIRECCIÓN",
    sch_label_notes: "¿QUÉ ESTÁ PASANDO? (OPCIONAL)",
    sch_ph_name: "Maria Lopez",
    sch_ph_email: "maria@correo.com",
    sch_ph_phone: "(305) 555-0142",
    sch_ph_address: "2455 SW 17th Ave, Miami, FL 33145",
    sch_ph_notes: "La llave de la cocina gotea cuando está cerrada; la puerta del baño se atasca en verano.",
    sch_step4_deposit: "Reserva tu cita con $49",
    sch_step4_full: "Paga completo",
    sch_step4_card: "Tarjeta archivada",
    sch_step4_deposit_b: "Reembolsable hasta 12 hrs antes. Se aplica a tu visita.",
    sch_step4_full_b: "Paga el estimado completo ahora, reembolsable hasta 12 hrs antes.",
    sch_step4_card_b: "Cobramos después de la visita, solo lo que se debe.",
    sch_total_today: "Total hoy",
    sch_card_number: "NÚMERO DE TARJETA",
    sch_expiry: "VENCE",
    sch_cvc: "CVC",
    sch_zip: "ZIP",
    sch_secured: "Asegurado por Stripe · TLS 256-bit · PCI DSS Nivel 1",
    sch_back: "← Atrás",
    sch_continue: "Continuar →",
    sch_continue_pay: "Continuar al pago →",
    sch_processing: "Procesando…",
    sch_pay_card_save: "Guardar tarjeta y confirmar",
    sch_step5_title_pre: "¡Listo, ",
    sch_step5_title_default: "vecino",
    sch_step5_blurb_pre: "Confirmación enviada a",
    sch_step5_blurb_post: ". Te escribiremos 24 hrs y 30 min antes de tu visita.",
    sch_booking: "RESERVA",
    sch_when: "CUÁNDO",
    sch_where: "DÓNDE",
    sch_crew: "EQUIPO",
    sch_paid: "PAGADO",
    sch_crew_assigned: "Rico C. (te avisará al llegar)",
    sch_book_another: "Reservar otra",
    sch_add_cal: "Añadir al calendario",
    sch_services: [
      { id: "diag", name: "Visita Diagnóstico", duration: "60 min", desc: "Recorremos tu casa, documentamos problemas y proponemos un plan.", price: 49 },
      { id: "fix", name: "Reparación Individual", duration: "Hasta 2 hr", desc: "Un trabajo — llave, puerta, ventilador. Miembros ahorran 30%.", price: 49 },
      { id: "tune", name: "Mantenimiento Trimestral", duration: "2–3 hr", desc: "Cambio de filtros, sellado, detectores, ajuste de bisagras.", price: 49 },
      { id: "emer", name: "Emergencia (ETA 4 hrs)", duration: "INMEDIATO", desc: "Fuga activa, sin luz, sin llave. Solo miembros.", price: 99 },
    ],
    sch_hold: "DEPÓSITO",
    months: ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"],
    months_short: ["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"],
    dow: ["Do","Lu","Ma","Mi","Ju","Vi","Sá"],
    dow_full: ["Dom","Lun","Mar","Mié","Jue","Vie","Sáb"],

    rev_eyebrow: "◆ VECINOS QUE CONFÍAN",
    rev_title_1: "Hogares reales de Miami,",
    rev_title_word: "una",
    rev_title_2: "equipo muy leal.",
    rev_meta: "Verificado · Miembros de Miami",
    rev_member: "miembro desde 2024",
    reviews: [
      { name: "Maria L.", area: "Coral Gables", body: "El mismo equipo, cada visita. Conocen nuestra casa de 1962 mejor que nosotros. La semana pasada Rico notó que el calentador iba a fallar y lo cambió antes de inundar el garaje." },
      { name: "Daniel K.", area: "Brickell", body: "El depósito de $49 es brillante — dejé de llamar a handymen al azar que nunca llegaban. La membresía se paga sola en dos visitas." },
      { name: "Anabel T.", area: "Coconut Grove", body: "Reservé domingo en la noche, arreglado lunes en la mañana. Documentaron todo en la app para enviarlo al casero." },
      { name: "Jorge R.", area: "Little Havana", body: "Mi casa, su problema. Hablan inglés y español, tratan la casa de mi abuela con respeto, y los precios son honestos." },
    ],

    mem_eyebrow: "◆ MEMBRESÍA",
    mem_title_1: "Elige el plan que se ajuste",
    mem_title_2: "a tu",
    mem_title_word: "casa",
    mem_title_3: ".",
    mem_blurb: "Una cuota fija al mes para que tu casa siempre funcione. Cancela cuando quieras después de 2 meses — sin contratos ni letra chica.",
    mem_popular: "MÁS POPULAR",
    mem_choose: "Elegir",
    mem_per: "mes",
    tiers: [
      { name: "Básico", price: 39.99, desc: "Empieza sin compromiso", features: ["1 visita al mes incluida","Hasta 1 hora de trabajo","Reparaciones básicas incluidas","Respuesta en 48 horas","Materiales no incluidos"] },
      { name: "Pro", price: 69.99, desc: "Aquí empieza el negocio de verdad", features: ["2 visitas al mes incluidas","Hasta 2 horas por visita","Prioridad en agenda (24–36 h)","Descuento en trabajos grandes","El mismo equipo, siempre"] },
      { name: "Premium", price: 99.99, desc: "Casas grandes o clientes cómodos", features: ["4 visitas al mes incluidas","Prioridad VIP — hoy o mañana","Soporte directo, te resolvemos ya","Pequeños materiales incluidos (tornillos, sellos)","Reporte anual de salud del hogar"] },
    ],

    // Reglas
    rules_eyebrow: "◆ REGLAS CLARAS",
    rules_title_1: "Alcance honesto,",
    rules_title_word: "sin sorpresas",
    rules_title_2: ".",
    rules_blurb: "Te decimos desde el inicio qué está cubierto, qué no, y cuánto puede durar una visita. Así la membresía sigue funcionando — para ti y para nosotros.",
    rules_yes_h: "LO QUE SÍ HACEMOS",
    rules_no_h: "FUERA DE ALCANCE",
    rules_extra_h: "LETRA CLARA",
    rules_yes_items: ["Plomería básica de cocina y baño", "Electricidad básica", "Montajes, estantes e instalación", "Sellados y acabados", "Cambios pequeños de herrajes"],
    rules_no_items: ["Plomería mayor o repipe", "Electricidad compleja", "Remodelaciones y demolición", "Techos o reparaciones estructurales"],
    rules_extra_items: ["Tiempo máximo por visita (claro desde el inicio)", "Zona: Miami y áreas cercanas", "Visitas adicionales = cargo extra", "Materiales al costo en trabajos grandes"],

    foot_blurb: "Mantenimiento integral del hogar para familias de Miami. Cuidamos tu casa como la nuestra — porque casi todos vivimos en este vecindario también.",
    foot_addr: ["FixMyCasa, LLC","2455 SW 17th Ave, Miami FL 33145","FL CGC1532001 · Garantizado · Asegurado"],
    foot_services_h: "SERVICIOS",
    foot_company_h: "COMPAÑÍA",
    foot_hello_h: "HOLA",
    foot_company_items: ["Sobre nosotros", "Nuestro equipo", "Área de servicio", "Membresía", "Prensa", "Carreras"],
    foot_hours: "Lun–Sáb · 7am–7pm",
    foot_emergencies: "Emergencias 24/7",
    foot_copyright: "© 2026 FixMyCasa, LLC · Hecho con cariño en Miami",
    foot_terms: "Términos",
    foot_privacy: "Privacidad",
    foot_sitemap: "Mapa",

    acct: {
      nav: {
        home: "Inicio",
        visits: "Visitas",
        active_visit: "Visita activa",
        documents: "Documentos",
        properties: "Casas",
        membership: "Membresía",
        refer: "Invita a un vecino",
        profile: "Perfil",
        notifs: "Notificaciones",
        settings: "Ajustes",
        casa: "CASA",
        account: "CUENTA",
        sign_out: "Cerrar sesión",
        book_visit: "Agendar visita",
        live: "EN VIVO",
        search_ph: "Buscar visitas, docs, pros…",
      },
      dashboard: {
        greeting_pre: "Buenas,",
        attention_pre: "3 cosas necesitan atención.",
        attention_post: "Tu equipo llega en 3 días.",
        home_health: "SALUD DEL HOGAR",
        doing: "Todo",
        well: "bien.",
        summary: "Tu casa de 1962 está bien cuidada. 3 detalles para la próxima visita; nada urgente.",
        visits_since: "VISITAS DESDE 2022",
        saved_vs: "AHORRADO VS À LA CARTE",
        days_streak: "DÍAS DESDE LA ÚLTIMA REVISIÓN",
        days_value: "12 días",
        next_visit: "PRÓXIMA VISITA · EN 3 DÍAS",
        in_3_days: "EN 3 DÍAS",
        tune_up: "Mantenimiento trimestral",
        slot: "Mar, 28 abr · 4:00–7:00 PM · 2455 SW 17th",
        by_room: "Por habitación",
        recommended_next: "Próximas sugerencias",
        recent_activity: "Actividad reciente",
        view_history: "VER HISTORIAL →",
        view_all: "TODO →",
        confirm_details: "Confirmar detalles →",
        reschedule: "Reagendar",
        request_emergency: "Solicitar emergencia",
        included_in_plan: "Agregar 2 ítems a la próxima visita · +$0 incluido",
        greeting_date: "MARTES, 24 ABR",
        your_usual_crew: "TU EQUIPO · 9 AÑOS · 47 VISITAS",
        planned_label: "PLANIFICADO:",
        planned_items: "Cambio filtro · Sellado · Prueba detectores · +2",
        rooms: [
          { name: "Cocina",          health: 92, last: "hace 12 días", items: 0, color: "var(--sage)",       icon: "🍳" },
          { name: "Baño principal",  health: 78, last: "hace 5 meses", items: 1, color: "var(--gold)",       icon: "🚿" },
          { name: "Baño de visitas", health: 65, last: "hace 8 meses", items: 2, color: "var(--terracotta)", icon: "🛁" },
          { name: "Sala",            health: 88, last: "hace 12 días", items: 0, color: "var(--sage)",       icon: "🛋" },
          { name: "Lavandería",      health: 71, last: "hace 4 meses", items: 1, color: "var(--gold)",       icon: "🌀" },
          { name: "Patio y techo",   health: 54, last: "hace 11 meses",items: 3, color: "var(--terracotta)", icon: "🌴" },
        ],
        last_label: "ÚLT:",
        item_label: "ÍTEM",
        items_label: "ÍTEMS",
        recommendations: [
          { title: "Resellar bañera del baño de visitas", reason: "Último sellado hace 8 meses; pequeño moho en la junta.", time: "30 min", room: "Baño de visitas" },
          { title: "Cambiar filtro de A/C (paquete de 4)", reason: "Último cambio hace 11 semanas. Traemos los filtros.", time: "10 min", room: "Pasillo" },
          { title: "Ajustar marco de la mosquitera del patio", reason: "La foto de la última visita muestra deformación en la esquina NW.", time: "20 min", room: "Patio" },
        ],
        added: "AGREGADO",
        add: "AGREGAR",
        activity: [
          { ts: "12 abr · 3:14 pm", who: "Rico C.", what: "Cambió la brida del triturador de cocina · 47 min", tag: "FIX", color: "var(--sage)" },
          { ts: "12 abr · 3:48 pm", who: "Rico C.", what: "Subió 6 fotos antes/después de la cocina", tag: "DOC", color: "var(--gold)" },
          { ts: "02 abr · 8:02 am", who: "Sistema", what: "Mantenimiento trimestral agendado · 28 abr", tag: "BOOK", color: "var(--terracotta)" },
          { ts: "14 mar · 4:21 pm", who: "Ana M.", what: "Resellado de silicona · baño principal", tag: "FIX", color: "var(--sage)" },
        ],
      },
      manage: {
        visits: {
          title_1: "Cada visita,",
          title_2: "documentada.",
          since: "47 VISITAS DESDE NOV 2022",
          year_filter: "2026",
          all_categories: "Todas las categorías",
          export_csv: "Exportar CSV",
          col_job: "TRABAJO",
          col_date: "FECHA",
          col_pro: "PRO · TIEMPO",
          col_cost: "COSTO",
          col_status: "ESTADO",
          total_visits: "VISITAS TOTALES",
          hrs_work: "HRS DE TRABAJO",
          photos_logged: "FOTOS GUARDADAS",
          saved_vs_acart: "AHORRADO VS À LA CARTE",
          upcoming: "Próxima",
          done: "Completada",
          cancelled: "Cancelada",
          included: "Incluido",
          history: [
            { id: "FMC-48217", title: "Mantenimiento trimestral",             date: "28 abr 2026", status: "upcoming", pro: "Rico C.", duration: "—",         cost_key: "included", room: "Toda la casa",    room_key: "TODA LA CASA",    tags: ["MANTENIMIENTO"] },
            { id: "FMC-48104", title: "Cambio de brida del triturador",       date: "12 abr 2026", status: "done",     pro: "Rico C.", duration: "47 MIN",     cost_key: "included", room: "Cocina",           room_key: "COCINA",           tags: ["PLOMERÍA"],                photos: 6 },
            { id: "FMC-47992", title: "Resellado de silicona · baño principal",date: "14 mar 2026",status: "done",     pro: "Ana M.", duration: "1 H 12 MIN", cost_key: "included", room: "Baño principal",  room_key: "BAÑO PRINCIPAL",  tags: ["CARPINTERÍA"],             photos: 4 },
            { id: "FMC-47884", title: "Emergencia · desagüe de A/C atascado", date: "28 feb 2026", status: "done",     pro: "Rico C.", duration: "2 H 4 MIN",  cost: "$110",         room: "Pasillo",          room_key: "PASILLO",          tags: ["A/C","EMERGENCIA"],        photos: 8 },
            { id: "FMC-47720", title: "Mantenimiento trimestral del T1",       date: "21 ene 2026", status: "done",     pro: "Rico C.", duration: "2 H 35 MIN", cost_key: "included", room: "Toda la casa",    room_key: "TODA LA CASA",    tags: ["MANTENIMIENTO"],           photos: 12 },
            { id: "FMC-47602", title: "Baterías de alarmas de humo (×4)",     date: "14 dic 2025", status: "done",     pro: "Ana M.", duration: "22 MIN",      cost_key: "included", room: "Pasillos",         room_key: "PASILLOS",         tags: ["SEGURIDAD"],               photos: 2 },
          ],
          room_tags: {
            "KITCHEN": "COCINA",
            "PRIMARY BATH": "BAÑO PRINCIPAL",
            "HALLWAY": "PASILLO",
            "HALLWAYS": "PASILLOS",
            "WHOLE HOUSE": "TODA LA CASA",
          },
          cat_tags: {
            "TUNE-UP": "MANTENIMIENTO",
            "PLUMBING": "PLOMERÍA",
            "CARPENTRY": "CARPINTERÍA",
            "AC": "A/C",
            "EMERGENCY": "EMERGENCIA",
            "SAFETY": "SEGURIDAD",
          },
        },
        properties: {
          title_1: "Casas bajo tu",
          title_2: "cuidado.",
          since: "3 CASAS · 2 PLANES",
          add_property: "Agregar casa",
          book_visit: "Agendar visita",
          open_dashboard: "Ver panel",
          primary: "PRINCIPAL",
          last_visit: "ÚLTIMA VISITA",
          square_feet: "TAMAÑO",
          year_built: "AÑO · VISITAS",
          manage_access: "GESTIONAR ACCESO",
          invite_family: "O INVITA A UN FAMILIAR",
          health_col: "SALUD",
          plan_col: "PLAN",
          role_primary: "PRINCIPAL",
          role_caretaker: "CUIDADOR",
          role_owner: "DUEÑO",
        },
        membership: {
          title_1: "Estás en",
          title_2_brand: "Casa.",
          plan_active: "ACTIVO",
          member_since: "MIEMBRO DESDE 14 NOV 2022",
          visits: "VISITAS T2",
          used: "de 2 usadas",
          small_jobs: "TRABAJITOS",
          this_year: "este año",
          unlimited: "ilimitado",
          upgrade: "Cambiar a Hacienda · $149",
          manage_plan: "Gestionar plan",
          payment: "Pago",
          default_card: "FIXMYCASA · PREDETERMINADA",
          cardholder: "TITULAR",
          backup_card: "Agregar tarjeta de respaldo",
          billing_history: "Historial de cobros",
          invoice: "FACTURA",
          date: "FECHA",
          amount: "MONTO",
          status: "ESTADO",
          paid: "Pagado",
          download_all: "DESCARGAR TODO ↓",
          plan_blurb: "Dos visitas por trimestre, trabajitos de 60 min ilimitados, 30% de descuento en reparaciones mayores.",
          plan_name_label: "TU PLAN",
          plan_name: "Casa · $79/mes",
          invoices: [
            { id: "INV-2604-MO",  date: "15 abr 2026", amt: "$79.00",  what: "Casa · Mensual · Abril" },
            { id: "INV-2604-EMR", date: "28 feb 2026", amt: "$110.00", what: "Desagüe de A/C atascado · emergencia (miembros)" },
            { id: "INV-2603-MO",  date: "15 mar 2026", amt: "$79.00",  what: "Casa · Mensual · Marzo" },
            { id: "INV-2602-MO",  date: "15 feb 2026", amt: "$79.00",  what: "Casa · Mensual · Febrero" },
            { id: "INV-2601-MO",  date: "15 ene 2026", amt: "$79.00",  what: "Casa · Mensual · Enero" },
          ],
        },
        documents: {
          title_1: "El rastro de papel",
          title_2: "de tu hogar.",
          blurb: "Garantías, recibos, inspecciones y cada foto que hemos tomado. Todo buscable. Todo tuyo para siempre.",
          upload: "Subir",
          search_ph: "Buscar docs, habitaciones, fechas…",
          all_tab: "Todo",
          warranties: "Garantías · 8",
          receipts: "Recibos · 11",
          photos: "Fotos · 284",
          inspections: "Inspecciones · 4",
          before_after: "Fotos antes / después",
          warranties_section: "Garantías y recibos",
          from_label: "DESDE",
          exp_label: "VENCE",
          more_view: "VER MÁS →",
          grid_view: "VER EN CUADRÍCULA →",
          photos_label: "FOTOS",
          docs: [
            { name: "Garantía del condensador A/C · Trane",  t: "GARANTÍA",    date: "Mar 2024", exp: "Mar 2034", color: "var(--sage)" },
            { name: "Recibo de calentador de agua · Rheem",  t: "RECIBO",      date: "Ene 2025", exp: "—",        color: "var(--gold)" },
            { name: "Inspección del techo · Stevenson Roofing", t: "INSPECCIÓN", date: "Nov 2025", exp: "—",       color: "var(--terracotta)" },
            { name: "Triturador de basura · InSinkErator",   t: "GARANTÍA",    date: "Abr 2026", exp: "Abr 2030", color: "var(--sage)" },
            { name: "Seguro — Citizens",                     t: "SEGURO",      date: "Ago 2025", exp: "Ago 2026", color: "var(--gold)" },
          ],
          doc_tags: {
            "WARRANTY": "GARANTÍA",
            "RECEIPT": "RECIBO",
            "INSPECTION": "INSPECCIÓN",
            "INSURANCE": "SEGURO",
          },
          photo_cards: [
            { room: "Cocina",          date: "12 abr", count: 6,  label: "Cambio de triturador" },
            { room: "Baño principal",  date: "14 mar", count: 4,  label: "Resellado de silicona" },
            { room: "Pasillo",         date: "28 feb", count: 8,  label: "Emergencia A/C" },
            { room: "Toda la casa",    date: "21 ene", count: 12, label: "Mantenimiento T1" },
            { room: "Patio",           date: "03 dic", count: 5,  label: "Ajuste de mosquitera" },
            { room: "Garaje",          date: "14 nov", count: 4,  label: "Lámpara" },
          ],
        },
      },
      active_visit: {
        eyebrow: "CRONOGRAMA DE VISITA",
        miles_away_pre: "Rico está a",
        miles_away_word: "2 millas.",
        miles_away_post: "",
        blurb: "Te avisará al llegar. Cubrezapatos puestos, alfombrillas abajo — ya sabes cómo es.",
        call_rico: "Llamar a Rico",
        message_crew: "Mensaje al equipo",
        arrives: "◆ LLEGA",
        in_8_min: "EN 8 MIN",
        your_home: "TU CASA",
        shop: "TALLER · 9:32 AM",
        eta_time: "10:08",
        timeline_title: "Mantenimiento trimestral",
        visit_name: "Hoy · Rico C.",
        step1: "Trabajo agendado y confirmado",
        step2: "El equipo sale del taller",
        step3: "Recogió piezas en Home Depot",
        step4: "Llegando a tu casa",
        step5: "Inicio de recorrido · 60 min estimado",
        step6: "Cierre · fotos subidas",
        expect_today_label: "QUÉ ESPERAR HOY",
        expect_today_body: "Cambio de filtro · Sellado (2 baños) · Prueba de detector de humo · Revisión de pantalla del patio · Inspección de desagüe",
        crew_name: "Rico Cabrera",
        crew_meta: "VAN 03 · LIC #F-2841",
        live_pill: "En vivo · llega en 8 min",
      },
      profile: {
        title: "Tu información",
        you: "Tu info",
        addresses: "Direcciones",
        notifs: "Notificaciones",
        payment: "Pago",
        language: "Idioma",
        security: "Seguridad",
        data_privacy: "Datos y privacidad",
        sign_out: "Cerrar sesión",
        your_info: "Tu info",
        member_no: "MIEMBRO #FMC-1247 · CORAL GABLES",
        change_photo: "Cambiar foto",
        first_name: "Nombre",
        last_name: "Apellido",
        email: "Correo",
        phone: "Teléfono",
        verified: "Verificado",
        how_we_reach: "Cómo te contactamos",
        saved_ago: "GUARDADO HACE 2 MIN",
        text: "TEXTO",
        email_col: "CORREO",
        push: "PUSH",
        call: "LLAMADA",
        pro_eta: "El pro va en camino (30 min antes)",
        pro_eta_desc: "Te escribe cuando el equipo de mantenimiento sale del taller",
        pro_arrived: "El pro llegó",
        pro_arrived_desc: "Aviso de llegada",
        visit_complete: "Visita completa + fotos subidas",
        visit_complete_desc: "Incluye notas detalladas",
        reminder_24: "Visita próxima · recordatorio 24 hrs",
        recommended_items: "Ítems sugeridos para la próxima visita",
        recommended_items_desc: "Recordatorios trimestrales, sin presión",
        emergency_updates: "Actualizaciones de emergencia",
        emergency_updates_desc: "Ubicación del equipo cada 5 min",
        membership_billing: "Membresía / cobros",
        membership_billing_desc: "Recibos, renovaciones, cambios de tarjeta",
        tips_digest: "Consejos y resumen de salud del hogar",
        tips_digest_desc: "Mensual · cancela cuando quieras",
        quiet_hours: "Horas de silencio",
        quiet_hours_blurb: "No te escribiremos ni llamaremos en estos horarios salvo que sea una emergencia que tú iniciaste.",
        mon_fri: "LUN–VIE",
        sat: "SÁB",
        sun: "DOM",
        account_actions: "Acciones de cuenta",
        account_actions_blurb: "Pausar la membresía conserva tu historial. Eliminar borra todo en 30 días.",
        pause_membership: "Pausar membresía",
        delete_account: "Eliminar cuenta",
        settings_label: "◆ AJUSTES",
      },
      notifs: {
        eyebrow: "◆ BANDEJA · 5 RECIENTES",
        inbox_count: "5 RECIENTES",
        title_1: "Qué pasa en",
        title_2_word: "tu casa.",
        mark_all_read: "Marcar todo como leído",
        visit_confirmed: "Visita confirmada",
        visit_confirmed_body: "Mantenimiento trimestral · Mar 28 abr, 4:00 PM. Rico C. te escribirá 30 min antes de llegar.",
        filter_low: "Filtro bajo",
        filter_low_body: "Tu filtro de ventilación de cocina marca 28% — lo cambiamos en la próxima visita.",
        photos_uploaded: "Fotos subidas",
        photos_uploaded_body: "Rico subió 6 fotos antes/después del cambio de flange del triturador.",
        receipt_available: "Recibo disponible",
        receipt_available_body: "Sellado de baño principal — factura lista para descargar.",
        membership_renewed: "Membresía renovada",
        membership_renewed_body: "Plan Casa renovado automáticamente — $79 cobrados a Visa •• 4242.",
        just_now: "Ahora mismo",
        ago_2h: "Hace 2 h",
        yesterday: "Ayer",
        ago_apr14: "14 abr",
        ago_apr9: "9 abr",
      },
      settings: {
        eyebrow: "◆ CUENTA",
        title_1: "Tus",
        title_2_word: "preferencias.",
        language_label: "Idioma",
        language_help: "Inglés · Español",
        language_action: "Cambiar",
        tz_label: "Zona horaria",
        tz_help: "America/New_York (EST)",
        tz_action: "Cambiar",
        receipts_label: "Recibos y exportaciones",
        receipts_help: "Envío automático de recibos por correo después de cada visita",
        receipts_action: "Configurar",
        connected_label: "Servicios conectados",
        connected_help: "Google Calendar, Apple Pay, ninguno",
        connected_action: "Gestionar",
        twofa_label: "Autenticación en dos pasos",
        twofa_help: "Activada · texto a (305) 555-0142",
        twofa_action: "Gestionar",
        signout_label: "Cerrar sesión en todos lados",
        signout_help: "Fuerza un nuevo inicio de sesión en todos tus dispositivos",
        signout_action: "Cerrar sesión",
        delete_label: "Eliminar cuenta",
        delete_help: "Elimina tu perfil e historial después de 30 días",
        delete_action: "Eliminar",
      },
      refer: {
        eyebrow: "◆ DA $25, GANA $25",
        title_1: "Trae a un vecino,",
        title_word: "ahorren",
        title_2: "juntos.",
        blurb: "Por cada vecino de Miami que se una a FixMyCasa con tu código, los dos reciben $25 de descuento en su próxima visita. La mayoría de los miembros refieren a 2 vecinos en su primer año.",
        your_code: "TU CÓDIGO",
        copy: "Copiar",
        or_share: "O comparte tu enlace de invitación:",
        link_pre: "fixmycasa.miami/r/maria-casa",
      },
      auth: {
        common: {
          continue_google: "Continuar con Google",
          continue_apple: "Continuar con Apple",
          continue_phone: "Continuar con número de teléfono",
          or_use_email: "O USA CORREO",
          first_name: "Nombre",
          last_name: "Apellido",
          email: "Correo",
          password: "Contraseña",
          sign_up: "Registrarse",
          sign_in: "Iniciar sesión",
          forgot: "¿OLVIDASTE?",
          reset: "Restablecer contraseña",
          remember_me: "Mantenerme conectado en esta laptop",
        },
        signup: {
          step_1_of_2: "PASO 1 DE 2",
          title: "Crea tu cuenta",
          blurb: "30 segundos. No necesitas tarjeta para registrarte — solo para agendar.",
          terms: "Acepto los Términos y la Política de privacidad. Envíenme actualizaciones de visitas por texto.",
          create_account: "Crear cuenta",
          already_member: "¿Ya eres miembro?",
          sign_in_link: "Inicia sesión",
          left_eyebrow: "◆ PARA FAMILIAS DE MIAMI",
          left_title_1: "Tu casa,",
          left_title_word: "tranquilamente",
          left_title_2: "resuelta.",
          left_blurb: "Una cuenta. Un equipo que aprende tu hogar. Te avisamos en camino, enviamos fotos y guardamos notas que puedes buscar después.",
          benefit_book_title: "Agendar en dos toques",
          benefit_book_body: "Reagenda, cambia servicios o pide emergencia en tres toques.",
          benefit_doc_title: "Cada visita, documentada",
          benefit_doc_body: "Fotos antes/después, garantías, recibos — buscables para siempre.",
          benefit_reminders_title: "Recordatorios trimestrales",
          benefit_reminders_body: "Te avisamos cuando los filtros, el sellado o las alarmas necesitan atención.",
          joining_count: "Uniéndote a 2,847 hogares de Miami",
          pw_strong: "FUERTE",
          pw_chars: "12 caracteres",
          pw_case: "mayús/minús",
          pw_num: "número",
          pw_hint: "FUERTE · 12 caracteres · mayús/minús · número",
        },
        signin: {
          eyebrow: "◆ BIENVENIDO DE VUELTA",
          title_1: "Hola de nuevo,",
          title_word: "vecino.",
          blurb: "El historial de tu casa, tu equipo, tu próxima visita — todo donde lo dejaste.",
          forgot_link: "¿OLVIDASTE?",
          keep_signed_in: "Mantenerme conectado en esta laptop",
          sign_in_button: "Iniciar sesión",
          new_here: "¿Eres nuevo?",
          create_account_link: "Crea una cuenta →",
          right_eyebrow: "TU PRÓXIMA VISITA",
          right_subtitle: "9 años · tu equipo",
          your_next_visit: "Mantenimiento trimestral",
          next_visit_date: "Mar, 28 abr · 4:00–7:00 PM",
          upcoming: "Próxima",
          home_health_score: "SALUD DEL HOGAR",
          items_flagged: "3 ítems marcados · 7 bien",
          looking_great: "87 · Bien",
          quote: '"Conocen nuestra casa de 1962 mejor que nosotros."',
          quote_author: "— MARIA L., CORAL GABLES · MIEMBRO",
        },
        forgot: {
          title: "¿Olvidaste tu",
          title_word: "contraseña?",
          blurb: "Sin drama. Ingresa tu correo y te enviamos un enlace para restablecer. Expira en 30 minutos.",
          send_link: "Enviar enlace",
          back_to_signin: "← VOLVER A INICIAR SESIÓN",
        },
        reset: {
          title: "Establece una nueva",
          title_word: "contraseña.",
          blurb: "Elige algo seguro. Al menos 8 caracteres con letras y números.",
          new_password: "Nueva contraseña",
          confirm_password: "Confirmar nueva contraseña",
          save_password: "Restablecer contraseña",
          back_to_signin: "← VOLVER A INICIAR SESIÓN",
        },
      },
    },
  },
};
